import { MatPaginatorIntl } from '@angular/material/paginator';
import { digitsEnToFa } from '@persian-tools/persian-tools';

export function PersianPaginatorIntl() {
  const persianPaginatorIntl = new MatPaginatorIntl();

  persianPaginatorIntl.itemsPerPageLabel = 'تعداد موارد در هر صفحه :';
  persianPaginatorIntl.previousPageLabel = 'صفحه قبل';
  persianPaginatorIntl.nextPageLabel = 'صفحه بعد';
  persianPaginatorIntl.firstPageLabel = 'صفحه اول';
  persianPaginatorIntl.lastPageLabel = 'صفحه آخر';

  persianPaginatorIntl.getRangeLabel = (
    page: number,
    pageSize: number,
    length: number
  ) => {
    return digitsEnToFa(`${pageSize} از ${length} - صفحه ${++page}`);
  };
  return persianPaginatorIntl;
}
